/**
 * Onboarding Domain - i18n Translations
 *
 * Single namespace: onboarding
 *
 * @example
 * import { registerOnboardingTranslations } from '@onboarding/locales';
 * registerOnboardingTranslations();
 */

import esOnboarding from './es-MX/onboarding.json';

export const onboardingTranslations = {
  'es-MX': esOnboarding,
};

export { registerOnboardingTranslations, areOnboardingTranslationsLoaded } from './registerTranslations';
